const TokenKey = 'X-Token'
const SynthesisTokenKey = 'Synthesis-Token'

export function isLogin() {
  return !!localStorage.getItem(TokenKey)
}

export function getToken() {
  return localStorage.getItem(TokenKey)
}

export function setToken(token: string) {
  localStorage.setItem(TokenKey, token)
}

export function removeToken() {
  localStorage.removeItem(TokenKey)
}

// Synthesis token 管理
export function getSynthesisToken() {
  return localStorage.getItem(SynthesisTokenKey)
}

export function setSynthesisToken(token: string) {
  localStorage.setItem(SynthesisTokenKey, token)
}

export function removeSynthesisToken() {
  localStorage.removeItem(SynthesisTokenKey)
}
